import { Grid, Typography, useMediaQuery } from "@mui/material";
import { ArrayField, Datagrid, DateField, TextField, FunctionField, useNotify } from "react-admin";
import { settings } from "app";
import { getFile } from "server/components/DownloadFile";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import AddAdditionalTrainingRecommendationDialog from "./components/AddAdditionalTrainingRecommendationDialog";
import { SectionTitle } from "features/SectionTitle";

const AdditionalTrainingsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const notify = useNotify();

  return (
    <>
      <SectionTitle
        title="Допълнителни обучения"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayField source="additionalTrainings">
            <Datagrid
              bulkActionButtons={false}
              rowClick={false}
              sx={[settings.style.detailsDatagrid, { "& .RaDatagrid-headerCell": { textAlign: "left" } }]}
            >
              <TextField
                source="durationInDays"
                label="Дни"
                sortable={false}
              />
              <FunctionField
                label="Протокол"
                render={training =>
                  training.protocolDocumentId ? (
                    <Typography
                      sx={{
                        textDecoration: "underline",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                      onClick={() => getFile(training.protocolDocumentId, notify, "private")}
                    >
                      Изтегли
                    </Typography>
                  ) : (
                    "-"
                  )
                }
              />
              <DateField
                source="createdOn"
                label="Създаден на"
                locales="bg-BG"
                showTime
                sortable={false}
              />
            </Datagrid>
          </ArrayField>
        </Grid>

        <SecuredComponent permission={permissions.canManageAdvancedSpecializationSpecialists}>
          <FunctionField
            render={rec => (
              <AddAdditionalTrainingRecommendationDialog
                id={rec?.id}
                fullyCoversStudyDuration={rec?.fullyCoversStudyDuration}
              />
            )}
          />
        </SecuredComponent>
      </Grid>
    </>
  );
};

export default AdditionalTrainingsSection;
